// extracted by mini-css-extract-plugin
module.exports = {"Table":"styles_Table__zNkcK","hideOnSmallScreen":"styles_hideOnSmallScreen__XYFkC","hideOnLargeScreen":"styles_hideOnLargeScreen__meEsb"};